import React, { useState } from 'react';
import { Row, Col, Form, Button, Dropdown } from 'react-bootstrap';
// import './ProfessionalInfo.css';

function TailorFields({ formData, updateField }) {
  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const CustomDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = ''
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    return (
      <div>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            {selectedValue || `${title}${required ? ' *' : ''}`}
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedValue === option}
                    onClick={() => {
                      onSelect(field, option);
                      setLocalSearchTerm('');
                      setIsOpen(false);
                    }}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  // Helper functions for multi-select fields
  const toggleStitchingPreferences = (preference) => {
    const updated = formData.stitching_preferences?.includes(preference)
      ? formData.stitching_preferences.filter(item => item !== preference)
      : [...(formData.stitching_preferences || []), preference];
    updateField('stitching_preferences', updated);
  };

  // Tailor mode options
  const tailorModes = ["For Home", "For Company", "Both"];
  
  // Tailor specialization options - first 3 in buttons, rest in dropdown
  const tailorSpecializationsMain = ["Abaya", "Lehenga", "Sarees"];
  const tailorSpecializationsAdditional = [
    "Blouses", "Kurtis", "Tunics", "Gowns", "Pants", "Skirt", "Custom Designs", "All"
  ];
  
  // Stitching preferences - only 3 options, all as buttons
  const stitchingPreferences = ["Male", "Female", "Kids"];
  
  // Fabric preferences - first 3 in buttons, rest in dropdown
  const fabricPreferencesMain = ["Cotton", "Silk", "Linen"];
  const fabricPreferencesAdditional = [
    "Wool", "Chiffon", "Georgette", "All"
  ];
  
  // Style preferences - first 3 in buttons, rest in dropdown
  const stylePreferencesMain = ["Traditional", "Modern", "Embroidery"];
  const stylePreferencesAdditional = [
    "Fusion", "Plain", "Printed", "All"
  ];

  return (
    <>
      {/* Tailor Mode */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Tailor Mode *</h4>
        <Row className="g-3">
          {tailorModes.map((mode, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.tailor_mode === mode ? 'selected-button' : ''}`}
                onClick={() => updateField('tailor_mode', mode)}
              >
                {mode}
              </Button>
            </Col>
          ))}
        </Row>
      </div>

      {/* Tailor Type / Specialization */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Tailor Type / Specialization</h4>
        <Row className="g-3">
          {tailorSpecializationsMain.map((type, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.tailor_type === type ? 'selected-button' : ''}`}
                onClick={() => updateField('tailor_type', type)}
              >
                {type}
              </Button>
            </Col>
          ))}
        </Row>
        
        <div className="mt-3">
          <CustomDropdown
            title="Select additional specialization"
            field="tailor_type"
            options={tailorSpecializationsAdditional}
            selectedValue={formData.tailor_type}
            onSelect={updateField}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>
      </div>

      {/* Select Your Stitching Preferences */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Select Your Stitching Preferences</h4>
        <Row className="g-3">
          {stitchingPreferences.map((preference, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.stitching_preferences?.includes(preference) ? 'selected-button' : ''}`}
                onClick={() => toggleStitchingPreferences(preference)}
              >
                {preference}
              </Button>
            </Col>
          ))}
        </Row>
      </div>

      {/* Fabric Preference */}
       {/* Fabric Preference */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Fabric Preference</h4>
        <Row className="g-3">
          {fabricPreferencesMain.map((fabric, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.fabric_preference === fabric ? 'selected-button' : ''}`}
                onClick={() => updateField('fabric_preference', fabric)}
              >
                {fabric}
              </Button>
            </Col>
          ))}
        </Row>
        
        <div className="mt-3">
          <CustomDropdown
            title="Select additional Options"
            field="fabric_preference"
            options={fabricPreferencesAdditional}
            selectedValue={formData.fabric_preference}
            onSelect={updateField}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>
        
        {/* Add this section to display selected value */}
        {formData.fabric_preference && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Fabric Preference:</h6>
            <div className="d-flex flex-wrap gap-2">
              <div className="badge bg-primary d-flex align-items-center">
                {formData.fabric_preference}
                <button
                  type="button"
                  className="btn-close btn-close-white ms-2"
                  style={{ fontSize: '0.5rem' }}
                  onClick={() => updateField('fabric_preference', '')}
                  aria-label="Remove"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Style Preference */}
        {/* Style Preference */}
      <div className="mb-5">
        <h4 className="mb-3" style={{ color: "black" }}>Style Preference</h4>
        <Row className="g-3">
          {stylePreferencesMain.map((style, idx) => (
            <Col xs={6} sm={6} md={4} key={idx}>
              <Button
                variant="light"
                className={`language-btn jobtype-btn w-100 ${formData.style_preference === style ? 'selected-button' : ''}`}
                onClick={() => updateField('style_preference', style)}
              >
                {style}
              </Button>
            </Col>
          ))}
        </Row>
        
        <div className="mt-3">
          <CustomDropdown
            title="Select additional Options"
            field="style_preference"
            options={stylePreferencesAdditional}
            selectedValue={formData.style_preference}
            onSelect={updateField}
            menuClassName="personalinfo-nationality-menu"
          />
        </div>
        
        {/* Add this section to display selected value */}
        {formData.style_preference && (
          <div className="mt-3">
            <h6 className="mb-2">Selected Style Preference:</h6>
            <div className="d-flex flex-wrap gap-2">
              <div className="badge bg-primary d-flex align-items-center">
                {formData.style_preference}
                <button
                  type="button"
                  className="btn-close btn-close-white ms-2"
                  style={{ fontSize: '0.5rem' }}
                  onClick={() => updateField('style_preference', '')}
                  aria-label="Remove"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default TailorFields;